var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "card search-card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit }) {
                    return [
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-sm-12 col-md-2" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("申請日期"),
                              ]),
                              _c("ValidationProvider", {
                                attrs: { rules: { dateRangeRequired: true } },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("date-picker", {
                                            staticClass: "w-100",
                                            attrs: {
                                              type: "date",
                                              range: "",
                                              placeholder:
                                                "YYYY-MM-DD~YYYY-MM-DD",
                                            },
                                            model: {
                                              value: _vm.applyDateRange,
                                              callback: function ($$v) {
                                                _vm.applyDateRange = $$v
                                              },
                                              expression: "applyDateRange",
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-2" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("招募期限"),
                              ]),
                              _c("date-picker", {
                                staticClass: "w-100",
                                attrs: {
                                  type: "date",
                                  range: "",
                                  placeholder: "YYYY-MM-DD~YYYY-MM-DD",
                                },
                                model: {
                                  value: _vm.dueDateRange,
                                  callback: function ($$v) {
                                    _vm.dueDateRange = $$v
                                  },
                                  expression: "dueDateRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-2" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              { attrs: { for: "ManpowerDemandNo" } },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Basic.DemandNo")) + " "
                                ),
                              ]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.opening.ManpowerDemandNo,
                                  expression: "opening.ManpowerDemandNo",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "ManpowerDemandNo",
                                placeholder: "請輸入關鍵字",
                              },
                              domProps: { value: _vm.opening.ManpowerDemandNo },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.getOpening({
                                    page: _vm.tableInfo.page,
                                    per_page: _vm.tableInfo.per_page,
                                  })
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.opening,
                                    "ManpowerDemandNo",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-2" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("需求單名稱"),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.opening.manpowerDemandName,
                                  expression: "opening.manpowerDemandName",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "請輸入關鍵字",
                              },
                              domProps: {
                                value: _vm.opening.manpowerDemandName,
                              },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.getOpening({
                                    page: _vm.tableInfo.page,
                                    per_page: _vm.tableInfo.per_page,
                                  })
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.opening,
                                    "manpowerDemandName",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-2" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(_vm._s(_vm.i18n("Position.PositionName"))),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.opening.PositionName,
                                  expression: "opening.PositionName",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "PositionName",
                                placeholder: "請輸入關鍵字",
                              },
                              domProps: { value: _vm.opening.PositionName },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.getOpening({
                                    page: _vm.tableInfo.page,
                                    per_page: _vm.tableInfo.per_page,
                                  })
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.opening,
                                    "PositionName",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-search",
                              staticStyle: {
                                "margin-top": "30px",
                                "margin-left": "10px",
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  handleSubmit(
                                    _vm.getOpening({
                                      page: _vm.tableInfo.page,
                                      per_page: _vm.tableInfo.per_page,
                                    })
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.i18n("Buttons.Search")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "yahome-table-wrap" },
        [
          _c("VueBootstrap4Table", {
            staticClass: "opening-table",
            attrs: {
              rows: _vm.rows,
              columns: _vm.columns,
              config: _vm.config,
              "total-rows": _vm.totalData,
            },
            on: { "on-change-query": _vm.onChangeQuery },
            scopedSlots: _vm._u([
              {
                key: "QRcode",
                fn: function (props) {
                  return [
                    _c("img", {
                      staticStyle: {
                        border: "1px solid rgba(0, 0, 0, 0.2)",
                        "border-radius": "5px",
                        width: "40px",
                        padding: "1px",
                        cursor: "pointer",
                      },
                      attrs: {
                        src: require("@/assets/img/Qrcode.png"),
                        alt: "QRcode",
                        "data-toggle": "modal",
                        "data-target": "#qrcodeModal",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showQRCode(props.row)
                        },
                      },
                    }),
                  ]
                },
              },
              {
                key: "ManpowerData",
                fn: function (props) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "light",
                          content: `招募期限：${_vm.$common.dateFormatter(
                            props.row.RecruitmentDeadline
                          )}`,
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm btn-file",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.viewDemand(
                                  props.row.ManpowerDemandNo
                                )
                              },
                            },
                          },
                          [
                            _vm._v(" " + _vm._s(props.row.ManpowerDemandNo)),
                            _c("br"),
                            _vm._v(
                              " " + _vm._s(props.row.ManpowerDemandName) + " "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "ApplicantTime",
                fn: function (props) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$common.dateFormatter(props.cell_value))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "recruitStatus",
                fn: function (props) {
                  return [
                    _c("div", { staticClass: "recruit-status" }, [
                      _c(
                        "button",
                        {
                          staticClass: "status resume_list",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.goResumeList(props.row)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "count" }, [
                            _vm._v(_vm._s(props.row.ResumeCount)),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("DemandDetailModal"),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "qrcodeModal", tabindex: "-1" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "block",
                    "text-align": "center",
                    color: "#fff",
                    padding: "20px",
                  },
                },
                [_vm._v(" QRcode ")]
              ),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  [
                    _c("qrcode-vue", {
                      staticClass: "qrcode-wrap",
                      attrs: { value: _vm.QRcode, size: _vm.size, level: "H" },
                    }),
                  ],
                  _c("div", { staticStyle: { "margin-top": "5px" } }, [
                    _vm.QRcode
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.QRcode,
                              expression: "QRcode",
                            },
                          ],
                          staticStyle: { opacity: "0" },
                          attrs: { id: "copyText", type: "text", size: "5" },
                          domProps: { value: _vm.QRcode },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.QRcode = $event.target.value
                            },
                          },
                        })
                      : _vm._e(),
                    _c("br"),
                    _c(
                      "button",
                      {
                        ref: "copyButton",
                        staticStyle: {
                          background: "inherit",
                          border: "none",
                          "margin-bottom": "25px",
                        },
                        attrs: { "data-clipboard-target": "#copyText" },
                        on: { click: _vm.initClipboard },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: { copy_text: _vm.isCopy },
                            staticStyle: { color: "#fff" },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.i18n("Basic.CopyLink")) + " "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ],
                2
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }